export default "__VITE_ASSET__adf9ff0a__"